//Compliance

export const GetAllSuppliers = () => {
  return $.get('api/Supplier/GetAllSuppliers')
}

export const GetMemberDetails = (id) => {
  return $.get('Patron/GetMemberDetails?MemberId='+id)
}

export const AddSupplier = (model) => {
  return $.post('api/Supplier/AddSupplier', model)
}

export const UpdateSupplier = (model) => {

  return $.post('api/Supplier/UpdateSupplier', model)
}



export const DeleteSupplier = (id) => {
  return $.post('api/Supplier/DeleteSupplier?supplierId=' + id)
}







// WEBPACK FOOTER //
// ./src/pages/Administration/suppliers.service.js